import { useSearchParams } from "react-router-dom";
import { User, MapPin, Heart, Search, Package, Receipt, MessageSquare, Coins, Bell, Shield, Ban, Repeat } from "lucide-react";
import { MyListingsTab, MessagesTab, ProposalsTab } from "@/pages/account/Social";
import { OrdersTab } from "@/pages/account/Orders";
import { PaymentsTab } from "@/components/Services";
import { CreditCard } from "lucide-react";
import { useI18n } from "@/i18n";
import { useAuth } from "@/context/AuthContext";
import { ProfileTab, AddressesTab, FavoritesTab, SearchesTab, WalletTab, NotificationsTab, PrivacyTab, BlockedTab, ComingTab } from "@/pages/account/Tabs";

const TABS = [
  ["profile", User], ["addresses", MapPin], ["favorites", Heart], ["searches", Search], ["listings", Package],
  ["messages", MessageSquare], ["proposals", Repeat], ["orders", Receipt], ["payments", CreditCard], ["wallet", Coins], ["notifications", Bell], ["privacy", Shield], ["blocked", Ban],
];

const Body = ({ tab, t }) => {
  switch (tab) {
    case "addresses": return <AddressesTab />;
    case "favorites": return <FavoritesTab />;
    case "searches": return <SearchesTab />;
    case "listings": return <MyListingsTab />;
    case "proposals": return <ProposalsTab />;
    case "orders": return <OrdersTab />;
    case "payments": return <PaymentsTab />;
    case "messages": return <MessagesTab />;
    case "wallet": return <WalletTab />;
    case "notifications": return <NotificationsTab />;
    case "privacy": return <PrivacyTab />;
    case "blocked": return <BlockedTab />;
    default: return <ProfileTab />;
  }
};

export default function AccountPage() {
  const { t } = useI18n();
  const { user } = useAuth();
  const [params, setParams] = useSearchParams();
  const tab = params.get("tab") || "profile";
  return (
    <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6" data-testid="account-page">
      <div className="flex flex-wrap items-center gap-3">
        <h1 className="text-3xl font-bold sm:text-4xl">{t("account.title")}</h1>
        <span className="pill bg-[#EFE9FB] text-[#3B1272]" data-testid="account-role-badge">{user.role === "pro" ? t("seller.professional") : t("seller.private")}</span>
      </div>
      <div className="mt-6 grid gap-6 lg:grid-cols-[240px_1fr]">
        <nav className="no-scrollbar flex gap-1 overflow-x-auto lg:flex-col" data-testid="account-tabs">
          {TABS.map(([k, Icon]) => (
            <button key={k} onClick={() => setParams({ tab: k })} data-testid={`account-tab-${k}`}
              className={`flex shrink-0 items-center gap-2.5 rounded-xl px-3.5 py-2.5 text-left text-sm font-semibold transition-colors ${tab === k ? "bg-[#3B1272] text-white" : "text-[#1E1B2E] hover:bg-[#EFE9FB]"}`}>
              <Icon className="h-4 w-4" />{t(`account.tabs.${k}`)}
            </button>
          ))}
        </nav>
        <section className="card-soft min-h-[400px] p-5 sm:p-7"><h2 className="mb-5 text-lg font-bold">{t(`account.tabs.${tab}`)}</h2><Body tab={tab} t={t} /></section>
      </div>
    </div>
  );
}
